import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserService } from '@app/services';
import { Router } from '@angular/router';
import { PATH } from '@app/constants';

@Component({
  selector: 'mnf-modal-knowledge-risks',
  templateUrl: './modal-knowledge-risks.component.html',
  styleUrls: ['./modal-knowledge-risks.component.scss']
})

export class ModalKnowledgeRisks implements OnInit {

  checkoutValidate: UntypedFormGroup;
  submitted = false;

  signature: Date | number = new Date();

  email: string;
  fullname: string; name: string; fatherSurname: string; motherSurname: string;
  valueModal: any;
  currencyDate: Date;

  constructor(private modal: MatDialogRef<ModalKnowledgeRisks>, private fb: UntypedFormBuilder, private userSer: UserService, private router: Router,) { }

  ngOnInit() {

    this.userSer.getUserRegInfo().subscribe(r => {
      this.email = r.email;
      this.name = r.name;
      this.fatherSurname = r.fatherSurname;
      this.motherSurname = r.motherSurname;
      this.fullname = `${this.name} ${this.fatherSurname} ${this.motherSurname}`;
    });

    this.checkoutValidate = this.fb.group({
      firstCheckOut: [{ value: true, disabled: this.submitted }, Validators.requiredTrue],
      secondCheckOut: [{ value: true, disabled: this.submitted }, Validators.requiredTrue],
      thirdCheckOut: [{ value: true, disabled: this.submitted }, Validators.requiredTrue],
      fourthCheckOut: [{ value: true, disabled: this.submitted }, Validators.requiredTrue],
      fifthCheckOut: [{ value: true, disabled: this.submitted }, Validators.requiredTrue],
      sixthCheckOut: [{ value: true, disabled: this.submitted }, Validators.requiredTrue],
      seventhCheckOut: [{ value: true, disabled: this.submitted }, Validators.requiredTrue],
      eighthCheckOut: [{ value: true, disabled: this.submitted }, Validators.requiredTrue],
    });
  }

  accept() {
    this.modal.close(this.checkoutValidate.valid);

    if(this.checkoutValidate.valid) {
      this.valueModal = true;
      this.userSer.setTermsRisk(this.email, this.valueModal).subscribe((a) => {
        window.location.reload();
        this.router.navigate([PATH.HOME])
      });

    } else {
      this.valueModal = false;
    }


  }

}
